<template>
    <div
        class="fixed bg-bay text-md p-4 pr-8 pl-8 w-fit h-fit rounded-lg pr-4 pl-4"
        style="
        top: 200;

        right: 0px;

        width: 600px;
        "
        :style="{ position: 'absolute', top: topPosition + 'px', right: leftPosition + 'px' }"
        @mousedown="startDragging"
    >
        <div class="header flex flex-col gap-4">
            <h2 class="text-2xl font-semibold">Component Manager</h2>
            <div class="flex gap-2 menu-filter">
                <template v-for="key in Object.keys(this.categories)">
                    <button class="bg-main p-3 rounded-md text-white">{{ key }}</button>
                </template>
            </div>
        </div>

        <div class="results flex flex-col gap-4">
            <div class="category flex flex-col gap-2" v-for="(results, index) in this.categories">
                <h2 class="text-xl mt-4 font-semibold">{{ index }}</h2>
                <div class="result-list flex gap-2">
                    <template v-for="result in results">
                        <button class="hover:opacity-70" style="width: 33%;" draggable="true" @dragstart="onDragStart($event, result.uuid, result.data)">
                            <div class="rounded-xl bg-bay w-full h-48" style="height: 6vw; background: url('https://assets.squarespace.com/static-images/conversion/Blueprint_Card_en-US-9f435956fe.jpeg') center center / cover;"></div>
                            <h4 class="pb-2 pt-2 text-left">{{ result.title }}</h4>

                        </button>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            topPosition: 50, // Initial top position in pixels
            leftPosition: 100, // Initial left position in pixels
            isDragging: false, // Flag to track dragging state
            mouseX: 0, // Mouse X position for dragging calculation
            mouseY: 0, // Mouse Y position for dragging calculation
        };
    },
    props: {
        categories: Object,
        onDragStart: {
            type: Function,
            default: null,
        },
        onCancelDrag: {
            type: Function,
            default: null,
        },
        onDrop: {
            type: Function,
            default: null,
        },
    },
    methods: {
        startDragging(event) {
            this.isDragging = true;
            this.mouseX = event.clientX;
            this.mouseY = event.clientY;
            document.addEventListener('mousemove', this.moveDragging);
            document.addEventListener('mouseup', this.stopDragging);
        },
        moveDragging(event) {
            if (!this.isDragging) return;

            const deltaX = event.clientX - this.mouseX;
            const deltaY = event.clientY - this.mouseY;

            this.topPosition += deltaY;
            this.leftPosition -= deltaX;

            this.mouseX = event.clientX;
            this.mouseY = event.clientY;
        },
        stopDragging() {
            this.isDragging = false;
            document.removeEventListener('mousemove', this.moveDragging);
            document.removeEventListener('mouseup', this.stopDragging);
        },
        handleDblClick(event) {
          if (event.ctrlKey) {



            const deltaX = event.clientX - this.mouseX;
            const deltaY = event.clientY - this.mouseY;

            this.topPosition += deltaY;
            this.leftPosition -= deltaX;

            this.mouseX = event.clientX;
            this.mouseY = event.clientY;

            // this.topPosition = 50, // Initial top position in pixels
            // this.leftPosition = 100, // Initial left position in pixels
            // this.isDragging = false, // Flag to track dragging state
            // this.mouseX = 0, // Mouse X position for dragging calculation
            // this.mouseY = 0 // Mouse Y position for dragging calculation
          }
        }
    },
    mounted() {
        document.body.addEventListener('dblclick', this.handleDblClick);
      },
      beforeDestroy() {
        document.body.removeEventListener('dblclick', this.handleDblClick);
      }
};
</script>
